import { logout } from 'action/AuthAction';
import axios from 'axios';
import { store } from '../Store';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '',
  headers: {
    'Content-Type': 'application/json',
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
      const { status, data } = error.response;

      if (status === 401 || data?.message?.toLowerCase()?.includes("token")) {
        console.warn("Token expired or unauthorized. Logging out...");

        store.dispatch(logout());

        localStorage.clear();
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;